/**
 * React Query Client Configuration
 * Following TanStack Query v5 best practices from Context7
 */

import { QueryClient } from '@tanstack/react-query';

function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Data considered fresh for 5 minutes
        staleTime: 1000 * 60 * 5,
        // Garbage collection after 30 minutes
        gcTime: 1000 * 60 * 30,
        // Retry failed queries 3 times
        retry: 3,
        // Refetch on window focus
        refetchOnWindowFocus: true,
        // Don't refetch on mount if data is fresh
        refetchOnMount: true,
        // Don't refetch on reconnect by default
        refetchOnReconnect: true,
      },
      mutations: {
        // Retry failed mutations once
        retry: 1,
      },
    },
  });
}

// Singleton pattern for browser
let browserQueryClient: QueryClient | undefined;

export function getQueryClient(): QueryClient {
  // Server: always create a new query client
  if (typeof window === 'undefined') {
    return createQueryClient();
  }

  // Browser: reuse the same query client
  if (!browserQueryClient) {
    browserQueryClient = createQueryClient();
  }

  return browserQueryClient;
}

// Export a default instance for simple use cases
export const queryClient = getQueryClient();
